import { Button } from 'antd';
import { ListTable, ModalView, TableFilters } from '../../../uiComponents';
import { useSelector } from 'react-redux';
import { formatPrice } from '../../../../util/formatPrice';
import { getMedicalCommissions } from '../../../../appRedux/actions';
import {
  commissionConst,
  filterNoApprove,
  filters,
  filtersMedical,
  searchFilters,
  searchInputInitialValues,
} from '../../../../constants/Commissions.const';
import { mainBranch } from '../../../../constants/Branch.const';
import { useState } from 'react';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { UpdateCommissionAgent } from '../../Agenda/UpdateCommissionAgent';
import { roleAliasConst, roleConst } from '../../../../constants';
import { MedicalCommissionModalBody } from '../MedicalCommissionModalBody';
import { getFullName } from '../../../../util';

export const CommissionMedical = () => {
  const {
    privileges: { medic_comission: medicalPrivileges = [] },
    role,
  } = useSelector((state) => state.userAuth);

  const { branchId: loggedBranchId, branch: branchLogged } = useSelector(
    (state) => state.userAuth
  );

  const [title, setTitle] = useState({});
  const { modal } = useCustomModal();
  const [child, setChild] = useState();

  const getCommissions = getMedicalCommissions;
  const approvePrivilege = medicalPrivileges.includes('approve');
  const editPrivilige = medicalPrivileges.includes('edit');

  let applicabeFilter;

  if (roleConst.medic === role) {
    applicabeFilter = filtersMedical;
  } else if (!approvePrivilege) {
    applicabeFilter = filterNoApprove;
  } else {
    applicabeFilter = filters;
  }

  const onModalClick = (userId, modalType, user) => {
    if (modalType === 'updateCommissionAgent') {
      setTitle(commissionConst.COMMISSION_AGENT_UPDATE);
      setChild(<UpdateCommissionAgent appointment={userId} />);
      modal();
    } else if (!modalType && roleAliasConst.doctor) {
      setTitle(`${getFullName(user)} - ${commissionConst.MEDICAL_MODAL_TITLE}`);
      setChild(
        <MedicalCommissionModalBody
          id={userId}
          privileges={editPrivilige}
          role={role}
        />
      );
      modal();
    }
  };

  const renderEmployeeNumber = (_, record) => {
    const selectedUser = record?.user;

    return (
      <Button
        type="link"
        htmlType="button"
        onClick={() => {
          onModalClick(selectedUser?.id, undefined, selectedUser);
        }}
      >
        {selectedUser?.kardex?.employeeNumber}
      </Button>
    );
  };

  const columns = [
    {
      title: 'No. de empleado',
      sorter: true,
      dataIndex: 'user',
      key: 'employeeNumber',
      render: renderEmployeeNumber,
    },
    {
      title: 'Nombre',
      sorter: true,
      dataIndex: 'user',
      key: 'name',
      render: (user) => user?.name,
    },
    {
      title: 'Apellido paterno',
      sorter: true,
      dataIndex: 'user',
      key: 'lastName',
      render: (user) => user?.lastName,
    },
    {
      title: 'Apellido materno',
      sorter: true,
      dataIndex: 'user',
      key: 'motherLastName',
      render: (user) => user?.motherLastName,
    },
    {
      title: 'Ventas Semana 1',
      dataIndex: 'saleWeekOne',
      key: 'saleWeekOne',
      render: (value) => formatPrice(value || 0),
    },
    {
      title: 'Ventas Semana 2',
      dataIndex: 'saleWeekTwo',
      key: 'saleWeekTwo',
      render: (value) => formatPrice(value || 0),
    },
    {
      title: 'ISR',
      dataIndex: 'isr',
      key: 'isr',
      render: (value) => formatPrice(value || 0),
    },
    {
      title: 'Total comisión',
      dataIndex: 'totalCommission',
      key: 'totalCommission',
      render: (value) => formatPrice(value || 0),
    },
  ];

  return (
    <>
      <TableFilters
        privileges={medicalPrivileges}
        searchFilters={searchFilters}
        filters={applicabeFilter}
        searchInputInitialValues={searchInputInitialValues}
        loggedBranchId={loggedBranchId}
        initialParams={
          !approvePrivilege && branchLogged !== mainBranch
            ? { branchId: loggedBranchId }
            : undefined
        }
      />

      <ListTable
        columns={columns}
        getDataFunction={getCommissions}
        privileges={medicalPrivileges}
      />

      <ModalView title={title}>{child}</ModalView>
    </>
  );
};
